import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All admin requests carry the httpOnly cookie. We never store the token
// in JavaScript-accessible storage (mitigates XSS token theft).
const ADMIN_AXIOS_CONFIG = { withCredentials: true };

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH.
//
// All CTAs land on our branded /login page first (Spanish + logo + brand),
// which then bounces to Emergent OAuth after user click. This keeps the
// full auth-security chain intact while giving the couple a premium,
// on-brand first impression.
export function startGoogleLogin(redirectPath = "/editor") {
    const next = encodeURIComponent(redirectPath);
    window.location.href = `/login?next=${next}`;
}

export const authApi = {
    me: () =>
        axios
            .get(`${API}/auth/me`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    logout: () =>
        axios
            .post(`${API}/auth/logout`, {}, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
};

export const adminApi = {
    login: (wedding_code) =>
        axios
            .post(`${API}/admin/login`, { wedding_code }, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    logout: () =>
        axios
            .post(`${API}/admin/logout`, {}, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    session: () =>
        axios
            .get(`${API}/admin/session`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    listGuests: () =>
        axios
            .get(`${API}/admin/guests`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    createGuest: (payload) =>
        axios
            .post(`${API}/admin/guests`, payload, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    updateGuest: (id, payload) =>
        axios
            .put(`${API}/admin/guests/${id}`, payload, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    deleteGuest: (id) =>
        axios
            .delete(`${API}/admin/guests/${id}`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    stats: () =>
        axios
            .get(`${API}/admin/stats`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    wedding: () =>
        axios
            .get(`${API}/admin/wedding`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    weddingFull: () =>
        axios
            .get(`${API}/admin/wedding/full`, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
    updateWedding: (payload) =>
        axios
            .put(`${API}/admin/wedding`, payload, ADMIN_AXIOS_CONFIG)
            .then((r) => r.data),
};

export const DIET_OPTIONS = [
    { id: "sin-gluten", label: "Sin gluten" },
    { id: "vegano", label: "Vegano" },
    { id: "vegetariano", label: "Vegetariano" },
    { id: "sin-lactosa", label: "Sin lactosa" },
    { id: "sin-frutos-secos", label: "Sin frutos secos" },
    { id: "halal", label: "Halal" },
    { id: "kosher", label: "Kosher" },
];

export const GUEST_TYPES = [
    { id: "adult", label: "Adulto" },
    { id: "child", label: "Niño/a" },
    { id: "baby", label: "Bebé" },
];

export function dietLabel(id) {
    return DIET_OPTIONS.find((d) => d.id === id)?.label || id;
}

export function typeLabel(id) {
    return GUEST_TYPES.find((t) => t.id === id)?.label || id;
}
